import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "testId"];
/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var containerStyles = css({
  position: 'relative',
  marginBlockEnd: "var(--ds-space-300, 24px)"
});
export var Container = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    testId = props.testId,
    rest = _objectWithoutProperties(props, _excluded);
  return (
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    jsx("div", _extends({
      css: containerStyles
    }, rest, {
      "data-testid": testId,
      ref: ref
    }), children)
  );
});
var spinnerBackdropStyles = css({
  display: 'flex',
  position: 'absolute',
  inset: 0,
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none'
});
export var SpinnerBackdrop = function SpinnerBackdrop(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return jsx("div", {
    css: spinnerBackdropStyles,
    "data-testid": testId && "".concat(testId, "--spinner-backdrop")
  }, children);
};
var spinnerContainerStyles = css({
  position: 'relative',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  insetBlockStart: 0
});
export var SpinnerContainer = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children;
  return jsx("div", {
    css: spinnerContainerStyles,
    ref: ref
  }, children);
});